import { gql } from "@apollo/client";

export const READ_INCREMENTAL_UPGRADE_VERSIONS_NAME =
  "ReadIncrementalUpgradeVersions";
export const READ_INCREMENTAL_UPGRADE_VERSIONS_QUERY = gql`
  query ${READ_INCREMENTAL_UPGRADE_VERSIONS_NAME}($version: String) {
    incremental_upgrade(version: $version) {
      id_version
      version
    }
  }
`;

export const READ_INCREMENTAL_UPGRADE_PACKAGES_NAME =
  "ReadIncrementalUpgradeFiles";
export const READ_INCREMENTAL_UPGRADE_PACKAGES_QUERY = gql`
  query ${READ_INCREMENTAL_UPGRADE_PACKAGES_NAME}(
    $cursor: String
    $first: Int = 25
    $version: String
    $filename: String
  ) {
    incremental_upgrade(version: $version) {
      packages(
        after: $cursor
        first: $first
        filename__icontains: $filename
      ) {
        edges {
          node {
            filename
            checksum
            git_revision
            id_package
            id_version
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

export const READ_INCREMENTAL_UPGRADE_REPOS_NAME =
  "ReadIncrementalUpgradeFiles";
export const READ_INCREMENTAL_UPGRADE_REPOS_QUERY = gql`
  query ${READ_INCREMENTAL_UPGRADE_REPOS_NAME}(
    $cursor: String
    $first: Int = 25
    $version: String
    $filename: String
  ) {
    incremental_upgrade(version: $version) {
      repos(
        after: $cursor
        first: $first
        filename__icontains: $filename
      ) {
        edges {
          node {
            filename
            id_package
            id_version
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
`;

export const CREATE_INCREMENTAL_UPGRADE_VERSION = gql`
  mutation CreateIncrementalUpgradeVersion($version: String!) {
    create_incremental_upgrade_version(version: $version) {
      success
      message
    }
  }
`;

export const DELETE_INCREMENTAL_UPGRADE_VERSION = gql`
  mutation DeleteIncrementalUpgradeVersion($ids: [Int!]!) {
    delete_incremental_upgrade_version(ids: $ids) {
      success
      message
    }
  }
`;

export const UPLOAD_INCREMENTAL_UPGRADE_FILES = gql`
  mutation UploadIncrementalUpgradeFiles(
    $files: [Upload]!
    $version: String!
    $file_type: FileTypeEnum!
  ) {
    create_incremental_upgrade_files(
      files: $files
      version: $version
      file_type: $file_type
    ) {
      success
      message
    }
  }
`;

export const DELETE_INCREMENTAL_UPGRADE_FILES = gql`
  mutation DeleteIncrementalUpgradeFiles($ids: [Int!]!) {
    delete_incremental_upgrade_files(ids: $ids) {
      success
      message
    }
  }
`;
